import React, { useEffect, useRef, useState } from "react";

/**
 * Landing page after Google OAuth consent.
 * The backend already exchanged the code — this page just reads ?success=1 or ?error=...
 * and either notifies the opener (popup flow) or navigates to /integrations (redirect flow).
 */
const GoogleOAuthCallbackPage: React.FC = () => {
  const [status] = useState<"loading" | "success" | "error">(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("error")) return "error";
    if (params.get("success") === "1") return "success";
    return "error";
  });

  const [errorMessage] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get("error") ?? "Respuesta inesperada del servidor";
  });

  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    if (status !== "success") return;

    if (window.opener) {
      try {
        window.opener.postMessage(
          { type: "GOOGLE_OAUTH_SUCCESS" },
          window.location.origin
        );
      } catch {
        // cross-origin — ignore
      }
      window.close();
    } else {
      window.location.href = "/integrations";
    }
  }, [status]);

  return (
    <div>
      <s-page heading="Conectar Google Sheets">
        <s-section>
          <s-stack direction="block" alignItems="center" gap="large-200">
            {status === "loading" && (
              <>
                <s-spinner />
                <s-text color="subdued">
                  Verificando tu cuenta de Google...
                </s-text>
              </>
            )}
            {status === "success" && (
              <>
                <s-icon type="check-circle-filled" />
                <s-text>
                  ¡Cuenta de Google conectada correctamente! Redirigiendo...
                </s-text>
              </>
            )}
            {status === "error" && (
              <>
                <s-banner tone="critical">
                  <s-text>Error al conectar con Google: {errorMessage}</s-text>
                </s-banner>
                <s-button
                  onClick={() => (window.location.href = "/integrations")}
                >
                  Volver a Integraciones
                </s-button>
              </>
            )}
          </s-stack>
        </s-section>
      </s-page>
    </div>
  );
};

export default GoogleOAuthCallbackPage;
